/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PatchedAccessRule
 */
export interface PatchedAccessRule {
  /**
   *
   * @type {number}
   * @memberof PatchedAccessRule
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedAccessRule
   */
  readonly url?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedAccessRule
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof PatchedAccessRule
   */
  writeAccess?: boolean;
}

/**
 * Check if a given object implements the PatchedAccessRule interface.
 */
export function instanceOfPatchedAccessRule(value: object): value is PatchedAccessRule {
  return true;
}

export function PatchedAccessRuleFromJSON(json: any): PatchedAccessRule {
  return PatchedAccessRuleFromJSONTyped(json, false);
}

export function PatchedAccessRuleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedAccessRule {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    url: json["url"] == null ? undefined : json["url"],
    email: json["email"] == null ? undefined : json["email"],
    writeAccess: json["write_access"] == null ? undefined : json["write_access"],
  };
}

export function PatchedAccessRuleToJSON(json: any): PatchedAccessRule {
  return PatchedAccessRuleToJSONTyped(json, false);
}

export function PatchedAccessRuleToJSONTyped(
  value?: Omit<PatchedAccessRule, "id" | "url"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    email: value["email"],
    write_access: value["writeAccess"],
  };
}
